import {
  FieldValues,
  UseFormClearErrors,
  UseFormGetValues,
  UseFormReset,
  UseFormSetValue,
  UseFormTrigger,
} from "react-hook-form";
import { atomFamily } from "recoil";

import { IExtendableDto } from "../../dto";
import { EditFormMode } from "../../enums";
import { IDynamicEditFormRoot, RydeUiUnit } from "../../models";

export const schemaRootAF = atomFamily<
  IDynamicEditFormRoot | undefined,
  RydeUiUnit
>({
  key: "schemaRootSF",
  default: undefined,
});

export const fieldValuesAF = atomFamily<FieldValues, RydeUiUnit>({
  key: "fieldValuesAF",
  default: () => ({}),
});

export const dynamicFormTabIndexAF = atomFamily<number, RydeUiUnit>({
  key: "dynamicFormTabIndexAF",
  default: 0,
});

export const editFormDataAF = atomFamily<
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  any | undefined,
  [RydeUiUnit, EditFormMode]
>({
  key: "editFormDataAF",
  default: undefined,
});

export const editFormDataInitialSnapshotAF = atomFamily<
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  any | undefined,
  [RydeUiUnit, EditFormMode]
>({
  key: "editFormDataInitialSnapshotAF",
  default: undefined,
});

interface IHookFormContext {
  getValues: UseFormGetValues<IExtendableDto>;
  setValue: UseFormSetValue<IExtendableDto>;
  trigger: UseFormTrigger<IExtendableDto>;
  reset: UseFormReset<IExtendableDto>;
  clearErrors: UseFormClearErrors<IExtendableDto>;
  dirtyFields: Partial<
    Readonly<{
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      [x: string]: any;
      id?: boolean | undefined;
      metadata?: object | undefined;
    }>
  >;
}

export const hookFormContextAF = atomFamily<
  IHookFormContext | undefined,
  RydeUiUnit
>({
  key: "hookFormContextAF",
  default: undefined,
  dangerouslyAllowMutability: true,
});
